const styleOverrides = {
  root: {
    padding: '4px',
    margin: '-4px',
  },
};

export default styleOverrides;
